import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=c05e97d0&scoped=true&"
import script from "./customTable.vue?vue&type=script&lang=js&"
export * from "./customTable.vue?vue&type=script&lang=js&"
import style0 from "./customTable.vue?vue&type=style&index=0&id=c05e97d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05e97d0",
  null
  
)

export default component.exports